import { useEffect } from "react";

const ConfirmPaidMembershipModal = ({ isOpen, onClose, onConfirm }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-base-100 rounded-lg p-6 w-96 shadow-lg">
        <h2 className="text-lg font-semibold">Xác nhận đã đóng hội phí</h2>
        <p className="mt-2">
          Bạn có chắc chắn xác nhận hội viên đã đóng hội phí không? Hành động
          này không thể hoàn tác.
        </p>
        <div className="mt-4 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700  rounded hover:bg-gray-300 transition"
          >
            Hủy
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-base  rounded  transition btn btn-success"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPaidMembershipModal;
